import t from "prop-types";
import FormControl from "@material-ui/core/FormControl";
import CommonButton from "@app/common/components/material_ui/Button";
import { TextField } from "juno-shared-components";
import Timer from "react-compound-timer";
import { CircularProgress } from "@material-ui/core";
import { useState } from "react";
import { Trans } from "@lingui/macro";
import { css } from "@emotion/react";


const propTypes = {
  allowResendOTP: t.bool.isRequired,
  isLoading: t.bool.isRequired,
  updateState: t.func.isRequired,
  onResendOTPClick: t.func.isRequired,
  otp: t.object.isRequired,
  ErrorMessage: t.array,
};


const rootStyle = css`
  .authenticated-submit {
    margin-top: 16px,
  }
`;

const UserNotVerified = ({ onResendOTPClick, isLoading, allowResendOTP, otp, updateState, ErrorMessage }) => {
  const [disabledButton, setDisabledButton] = useState(true);
  const checkValue = () => {
    if (Number.isNaN(parseInt(otp.current?.value.trim())) || otp.current?.value.length !== 6) {
      setDisabledButton(true);
    } else {
      setDisabledButton(false);
    }
  };

  return (
    <div css={rootStyle}>
      <div className="body1 body1-code-text-wrapper">
        <Trans>A 6 digit code has been sent to your mobile device and/or email address. Please enter it below.</Trans>
      </div>
      <div className="text-field-wrapper">
        <FormControl margin="normal" required fullWidth>
          <span><Trans>Write it down below</Trans></span>
          <Trans render={word => (
            <TextField
              placeholder={word.translation}
              id="code"
              name="fullname"
              autoFocus
              inputRef={otp}
              onChange={() => checkValue()}
            />
          )}
          >Submit Code
          </Trans>
        </FormControl>
      </div>
      <div className="buttonWrapper">
        <CommonButton
          type="button"
          fullWidth
          size="large"
          variant="contained"
          color="primary"
          disabled={!allowResendOTP}
          onClick={onResendOTPClick}
          className="secondary-action-btn"
        >
          {allowResendOTP ? (
            <Trans>Send a new code</Trans>
          ) : (
            <Timer
              initialTime={60 * 1000 * 4}
              direction="backward"
              formatValue={value => `${value < 10 ? `0${value}` : value}`}
              checkpoints={[{ time: 0, callback: () => updateState("allowResendOTP", true) }]}
            >
              <Timer.Minutes />:<Timer.Seconds />
            </Timer>
          )}
        </CommonButton>
      </div>
      <div className="buttonWrapper">
        <CommonButton
          type="submit"
          fullWidth
          size="large"
          variant="contained"
          color="primary"
          className="authenticated-submit"
          disabled={isLoading || disabledButton}
        >
          {isLoading ? (
            <CircularProgress size={24} />
          ) : (
            <Trans>Submit</Trans>
          )}
        </CommonButton>
      </div>
      {ErrorMessage}
    </div>
  );
};

UserNotVerified.propTypes = propTypes;

export default UserNotVerified;
